import React from 'react';
import T from 'prop-types';
import AppIcon from '../../../../../../components/AppIcon';

const ChartLegend = ({ selectedApps, hasAverage }) => (
  <div className="slides-chart-legend-block">
    {selectedApps.map(({ id, name, icon_url, color }) => (
      <div key={id} className="slides-chart-legend-item d-flex">
        <span className="slides-chart-legend-item-bullet" style={{ backgroundColor: color }} />
        <AppIcon url={icon_url} size={24} withBorder />
        <span className="slides-chart-legend-item-name text-truncate">{name}</span>
      </div>
    ))}
    {hasAverage && (
      <div className="slides-chart-legend-item d-flex hidden-sm-down">
        <span className="slides-chart-legend-item-bullet" style={{ backgroundColor: '#15385B' }} />
        <span className="slides-chart-legend-item-name w-100" style={{ width: 88 }}>
          Market Average
        </span>
      </div>
    )}
  </div>
);

ChartLegend.propTypes = {
  selectedApps: T.array.isRequired,
  hasAverage: T.bool,
};

export default ChartLegend;
